import React, { useEffect, useRef } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Accordion, Card } from 'react-bootstrap';
import SummaryHeader from './SummaryHeader';
import SummaryWrapper from './SummaryWrapper';
import { getFarmSummary, getFarmGraph, subscribeFarmAnalyseKPI, unsubscribeFarmAnalyseKPI } from '../../../actions/farm-monitor';
import { getDateRangeInfo } from '../../../actions/analyze';

const Summary = (props) => {
    const { farmId, search: { range, rangeId }, isRequestingPlanPlannedToDate, selectedPlanTypeId, summaryToggleCollapsed } = props;
    const farmRef = useRef();

    useEffect(() => {
        if (!farmId) return;
        props.actions.subscribeFarmAnalyseKPI({ farmId, range });
        return () => unsubscribeFarmAnalyseKPI();
    }, [farmId, rangeId])

    useEffect(() => {
        if (!farmId) return;
        const cb = (dateInfo) => {
            const params = { farmId: farmId, planTypeId: selectedPlanTypeId, ...dateInfo };

            props.actions.getFarmSummary(params);
            props.actions.getFarmGraph(params);
        }

        props.actions.getDateRangeInfo({ farmId, planTypeId: selectedPlanTypeId }, cb);
    }, [farmId, rangeId, selectedPlanTypeId, isRequestingPlanPlannedToDate]);

    return (
        <Accordion defaultActiveKey="0" style={summaryToggleCollapsed ? { height: 'auto' } : {}} className="farm__accordion">
            <Card ref={farmRef} className="farm__worked-details">
                <SummaryHeader ref={farmRef} />
                <Accordion.Collapse eventKey="0">
                    <SummaryWrapper />
                </Accordion.Collapse>
                <div className="image-watermark d-none">Powered by acuitusag</div>
            </Card>
        </Accordion>
    );
}

const mapStateToProps = state => {
    const farmId = state.farmMonitor.farmId;
    const selectedPlanTypeId = state.farmMonitor.selectedPlanTypeId;
    const planPlannedToDate = farmId && state.analyze.searchParams.plannedTodate[`${farmId}_${selectedPlanTypeId}`]
        ? state.analyze.searchParams.plannedTodate[`${farmId}_${selectedPlanTypeId}`] : null;

    return ({
        farmId: farmId,
        selectedPlanTypeId,
        isRequestingPlanPlannedToDate: planPlannedToDate ? planPlannedToDate.isRequesting : false,
        summaryDetails: state.farmMonitor.summaryByPlanTypeId[selectedPlanTypeId],
        summaryToggleCollapsed: state.farmMonitor.summaryToggleCollapsed,
        search: {
            range: state.analyze.searchParams.range,
            rangeId: state.analyze.searchParams.rangeId
        }
    });
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        getFarmSummary, getFarmGraph, subscribeFarmAnalyseKPI, unsubscribeFarmAnalyseKPI, getDateRangeInfo
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Summary);